import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { DeliAreaService } from '../../../service/deli-area/deli-area.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9171.component.html',
  styleUrls: ['wa9171.component.css']
})
export class Wa9171Component implements AfterViewInit {
  public componentTitle = 'WA9171:配送エリアマスタ登録';

  public owners: any;

  public ownerId: FormControl;
  public deliareaCd: FormControl;
  public deliareaTx: FormControl;

  public validation = validation;

  public working = false;
  private errorInfo = '';

  constructor(
    private router: Router,
    private ownerService: OwnerService,
    private deliAreaService: DeliAreaService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    (this.ownerId = new FormControl('', [Validators.required])),
      (this.deliareaCd = new FormControl('', [
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.code39),
        Validators.maxLength(validation.deliareaCd.maxLength)
      ])),
      (this.deliareaTx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.deliareaTx.maxLength)
      ])),
      (this.working = true);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.ownerService
      .get()
      .then(outputJson => {
        console.log(outputJson);
        this.owners = outputJson.owners;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    //const upduserId: number = (JSON.parse(sessionStorage.getItem('loginResult')))['user']['userId'];
    let errors = false;
    var deliareaCd = this.deliareaCd.value.trim();
    var deliareaTx = this.deliareaTx.value.trim();
    if (this.ownerId.errors !== null) {
      this.ownerId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.deliareaCd.errors !== null) {
      this.deliareaCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.deliareaTx.errors !== null) {
      this.deliareaTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    this.deliAreaService
      .post(this.ownerId.value, deliareaCd, deliareaTx, 'wa9171')
      .then(outputJson => {
        this.router.navigate(['wa9170']);
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9171/wa9171.component.ts